import { get, isObject, keyBy, size as _size, set, first, last, uniq } from 'lodash';
import v4 from 'uuid/v4';
import { getLicenseNumbers } from '../_shared/services/api.service';
import { getDrivers } from '../_shared/services/drivers.service';
import { sendManifest } from '../_shared/services/orders.service';
import { getRoutes } from '../_shared/services/routes.service';
import { getVehicles } from '../_shared/services/vehicles.service';
import { getAppConfig } from '../_shared/services/utils.service';
import moment from 'moment';
import XLSX from 'xlsx';
import { OrderStatus } from '../models/order';

export const defaultDateFormat = 'MMM D YYYY hh:mma';

export const sortByCreatedDate = (a, b) => {
  return (
    new Date(b.data.createdAt).getTime() - new Date(a.data.createdAt).getTime()
  );
};

const LABELS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const getLabelFromAlpha = i => {
  return LABELS[i];
}

export const sortByName = (a, b) => {
  if (a.name < b.name) { return -1; }
  if (a.name > b.name) { return 1; }
  return 0;
};

export const createPassword = () => {
  return 'MySecretPassword11!';
}

export const userIsVerfied = (user) => {
  return get(user, 'verified');
}

export const pullUserOutOfResp = (resp, opts = {}) => {
  if (opts.returnRaw) {
    return get(resp, 'data.user');
  }
  const user = get(resp, 'data.user', {});
  const userData = get(resp, 'data.user.data', {});
  const removeEmail = get(opts, 'removeEmail', true);
  delete user.data;
  if (removeEmail) {
    delete userData.email;
  }
  delete userData.userId;
  return {
    ...userData,
    ...user,
  };
}

export const buildErrorMsgFromForm = (objErrors, str) => {
  let message = str || '';
  for (let key in objErrors) {
    let obj = objErrors[key];
    if(obj.errors) {
      let all = obj.errors;
      all && all.map(e => {
        message += e.message + '\n';
      });
    } else {
      message = buildErrorMsgFromForm(obj, message);
    }
  }
  return message;
};

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

export const beforeImageUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    // eslint-disable-next-line no-undef
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    // eslint-disable-next-line no-undef
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
}

export const getContent = (content) => {
  return content();
};
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isLoggedIn = (sState) => {
  return get(sState, 'auth.user.sub');
};

export const inRange = (x, min, max) => {
  return (x - min) * (x - max) < 0;
};

export const convertHex = (hex, opacity) => {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
};

export const createHours = () => {
  const quarterHours = ['00', '15', '30', '45'];

  const hours = [];
  for (let i = 0; i < 24; i++) {
    for (let j = 0; j < 4; j++) {
      hours.push(('0' + i).slice(-2) + ':' + quarterHours[j]);
    }
  }

  return hours;
};

export const militaryToHours = (_time = '00:00') => {
  let time = _time.split(':');

  if (time.length < 2) {
    time = `${_time.slice(0, 2)}:${_time.slice(2)}`.split(':');
  }

  const hours = Number(time[0]);
  const minutes = Number(time[1]);
  const mins = minutes / 60;
  let timeValue = hours + mins;

  return timeValue;
};

export const testPassword = (password) => {
  var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
  return re.test(password);
};

export const uppercaseFirst = (str) => {
  return `${str.charAt(0).toUpperCase()}${str.substring(1, str.length)}`;
};

export const PWReqsMessage =
  // tslint:disable-next-line:max-line-length
  'Please fix the password you provided. It must include at least one number, one lowercase and one uppercase letter. And be at least six characters.';

export const userHasRole = (id, sState) => {
  let has = null;
  // set(sState, 'user.role', 2);
  if (Array.isArray(id)) {
    for (let i = 0; i < id.length; i++) {
      let _id = id[i];
      if (sState.user && sState.user.role === _id) {
        has = true;
        break;
      }
    }
  } else {
    has = sState.user && sState.user.role === id;
  }
  return has ? true : false;
};

export const userIsSuspended = (sState) => {
  return get(sState, 'user.verified') === 'suspended';
}

export const getRoleName = (id, sState) => {
  const {
    auth: { allRoles },
  } = sState;
  const role = allRoles.find(role => role.id === id);
  return role ? role.title : 'none';
};

export const filterBasedOnRoles = (
  routes,
  sState
) => {
  return (routes || []).map(r => ({ ...r, ...getConfig(`menu.${r.path}`, {}) })).filter(route => {
    let allowed = true;
    
    if (route && route.allowedRoles) {
      allowed = false;
      for (let i = 0; i < route.allowedRoles.length; i++) {
        if (userHasRole(route.allowedRoles[i], sState)) {
          allowed = true;
          break;
        }
      }
    }

    if (route && route.restrictRoles) {
      for (let i = 0; i < route.restrictRoles.length; i++) {
        if (userHasRole(route.restrictRoles[i], sState)) {
          allowed = false;
          break;
        }
      }
    }

    if (allowed && route.show !== undefined) {
      allowed = typeof route.show == 'function' ? route.show(route) : route.show;
    }

    return allowed;
  });
};

export const removeEmpty = (obj) => {
  for (let key in obj) {
    let o = obj[key];
    if (o === undefined || o === null || o.length === 0) {
      delete obj[key];
    }
    if (o !== null && typeof o === 'object') {
      o = o._isAMomentObject ? o.toISOString() : removeEmpty(o);
    }
  }
  return obj;
};

export const getNameFromState = (sState) => {
  const {
    user,
  } = sState;
  if (user) {
    const hasName = user.firstName && user.lastName;

    return hasName ? `${user.firstName} ${user.lastName}` : user.email;
  } else {
    return 'My Name';
  }
};

export const getUsersName = (user) => {
  return `${user.firstName} ${user.lastName}`.trim();
};

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
};

export const guid = () => {
  return v4();
};

export const uid = (length = 6) => {
  return parseInt(Math.ceil(Math.random() * Date.now()).toPrecision(length).toString().replace(".", ""))
}

export const getUrlParams = (url) => {
  let match;
  const search = /([^&=]+)=?([^&]*)/g;
  const decode = function (s) {
    return decodeURIComponent(s);
  };
  const searchFor = '?';
  const index = url.indexOf(searchFor) + searchFor.length;
  const str = url.substring(index, url.length);
  const query = str;

  let urlParams = {};

  while ((match = search.exec(query)))
    urlParams[decode(match[1])] = decode(match[2]);

  return urlParams;
};

export const validPhoneNumber = (str) => {
  return phoneNumberReg().test(str);
};

export const phoneNumberReg = () => {
  return new RegExp(
    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
  );
};

export const cleanCopy = (obj = {}) => {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (err) {
    console.warn(err);
    return obj;
  }
};

export const jparse = (str = '', fb = {}) => {
  try {
    return JSON.parse(str);
  } catch (err) {
    console.warn(err);
    return fb;
  }
};

export const userIsLoggedIn = (sState = {}) => {
  return get(sState, 'user.id');
}

export const validateEmail = (email) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const size = obj => {
  if (isObject(obj)) {
    return Object.keys(obj).length;
  } else {
    return _size(obj);
  }
}

export const stopProp = (e) => {
  e && e.stopPropagation && e.stopPropagation();
  e && e.preventDefault && e.preventDefault();
}

export const isLocal = process.env.NODE_ENV === 'development';

export const isDev = () => {
  const origin = get(window, 'location.origin', '');
  return !![
    'localhost',
    'gps-env-dev',
    'gps-multi-dev',
    'dev.gpsorders.com'
  ].find(f => origin.indexOf(f) > -1);
}

export const isStage = () => {
  const origin = get(window, 'location.origin', '');
  return !![
    'gps-env-stage',
    'gps-multi-stage',
    'stage.gpsone.delivery'
  ].find(f => origin.indexOf(f) > -1);
}

export const allowedExperimental = (list) => {
  list = list || [
    'bruce@vividconceptsllc.com',
    'joel@greenparcelservice.com',
    'johnnytester2186@gmail.com',
    'johnnytester2186+2@gmail.com',
    'johnnytester2186+3@gmail.com',
    'johnnytester2186+4@gmail.com',
    'johnnytester2186+da@gmail.com',
    'johnnytester2186+dispo@gmail.com',
    'johnnytester2186+enduser@gmail.com'
  ]
  const sState = get(window, 'STORE.getState', () => ({}))();
  const uemail = get(sState, 'user.email', '').toLowerCase();

  return list.includes(uemail);
}

export const getEnv = () => {
  const { host } = window.location;
  if (isLocal || host.includes('localhost')) {
    return 'local'
  } else if (host.includes('-dev')) {
    return 'dev';
  } else {
    return 'prod'
  }
}

// Card #266 — a human-facing tier label for admin notification subjects.
// APP_NAME (app.json) names the CLIENT (CO/NJ/GH/...), not the tier: stage and
// prod both build as "CO", so it cannot answer "which instance sent this?".
// isStage() is deliberately left alone — it gates the #151 daily-email redirect
// — so the broader host sniff lives here instead.
export const getEnvLabel = () => {
  const host = get(window, 'location.host', '');

  if (isLocal || host.includes('localhost')) { return 'LOCAL'; }
  if (isDev() || host.includes('-dev') || host.includes('dev.')) { return 'DEV'; }
  if (isStage() || host.includes('stage')) { return 'STAGE'; }

  return 'PROD';
}

const KEY_MAPS = {
  license: '{}',
  drivers: '{}',
  vehicles: '{}',
  routes: '{}',
};
export const loadLicense = async () => {
  const license = await getLicenseNumbers(false);
  KEY_MAPS.license = keyBy(license, 'License #');
};
export const loadLicenses = async () => {
  const [license, drivers, vehicles, routes] = await Promise.all([
    loadLicense(),
    getDrivers(),
    getVehicles(),
    getRoutes(),
  ]);
  // MAPS.license = keyBy(license, 'License #');
  KEY_MAPS.drivers = keyBy(drivers, 'id');
  KEY_MAPS.vehicles = keyBy(vehicles, 'id');
  KEY_MAPS.routes = JSON.stringify(keyBy(routes, 'id'));
};
window.LOADLICENSES = loadLicenses;

window.LOADLICENSE = loadLicense;

export let GPSID = '406R-00008';
export const loadGPSID = () => {
  GPSID = getConfig('defaultId', '406R-00008');
  return GPSID;
}

export const getRawLicense = (key, ifblank) => {
  return get(getKeyMaps('license'), key, ifblank);
}

export const getLicAddress = (key, include = ['Street Address', 'City', 'Zip']) => {
  const map = getRawLicense(key);

  return include.filter(i => !!get(map, i)).map(i => get(map, i)).join(', ');
}

export const getLicName = key => {
  const map = getRawLicense(key);

  const text = get(map, 'Licensee', '');
  const hasDBA = get(map, 'DBA');
  if (!text) return hasDBA || '';
  const sameName = hasDBA && `${hasDBA}`.trim().toLowerCase() === `${text}`.trim().toLowerCase();
  return hasDBA && !sameName ? `${text} - ${hasDBA}` : text;
}

export const getDriver = id => {
  return get(getKeyMaps('drivers'), id);
}

export const getKeyMaps = (k, fb) => {
  let str = get(KEY_MAPS, k);

  if (str && typeof str == 'string') {
    str = JSON.parse(str);
  }

  return str || fb;
}

export const getDriverByEmail = email => {
  const drivers = getKeyMaps('drivers');
  const id = Object.keys(drivers).find(k => {
    const driver = drivers[k];

    return get(driver, 'email', '').toLowerCase() == email.toLowerCase();
  })

  return getDriver(id);
}

export const getVehicle = id => {
  return get(getKeyMaps('vehicles'), id);
}

export const getRoute = id => {
  return get(getKeyMaps('routes'), id);
}

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const toMoney = num => {
  return formatter.format(num);
}

export const jformat = str => {
	return prettifyJson(str, true);
}
function prettifyJson(json, prettify) {
	if (typeof json !== 'string') {
			if (prettify) {
					json = JSON.stringify(json, undefined, 4);
			} else {
					json = JSON.stringify(json);
			}
	}
	return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
			function(match) {
					let cls = "<span>";
					if (/^"/.test(match)) {
							if (/:$/.test(match)) {
									cls = "<span class='text-danger'>";
							} else {
									cls = "<span>";
							}
					} else if (/true|false/.test(match)) {
							cls = "<span class='text-primary'>";
					} else if (/null/.test(match)) {
							cls = "<span class='text-info'>";
					}
					return cls + match + "</span>";
			}
	);
}

export const exportToCsv = (filename, rows) => {
  var processRow = function (row) {
    var finalVal = '';
    for (var j = 0; j < row.length; j++) {
      var innerValue = row[j] === null ? '' : row[j].toString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      } else if (row[j] instanceof Object) {
        innerValue = get(row[j], 'name', '');
      }
      var result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
      if (j > 0) finalVal += ',';
      finalVal += result;
    }
    return finalVal + '\n';
  };

  var csvFile = '';
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export const wait = (time = 1000) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), time);
  })
}

export const PageMedia = () => {
  var cssPagedMedia = (function () {
    var style = document.createElement('style');
    document.head.appendChild(style);
    return function (rule) {
        style.innerHTML = rule;
    };
  }());

  cssPagedMedia.size = function (size) {
    cssPagedMedia('@page { size: ' + size + '}');
  };

  cssPagedMedia.insert = function (str) {
    cssPagedMedia(`@page { ${str} }`);
  }

  return cssPagedMedia;
}

export const orderIsCheckedIn = order => {
  return !!get(order, 'data.order.checkedin')
}

export const orderIsCheckedOut = order => { //this is the client facing checkin
  return !!get(order, 'data.order.checkedout')
}

export const orderIsPickedUp = order => {
  return get(order, 'data.order.status') == OrderStatus.orderPickedUp;
}

export const orderIsRejected = order => { //this is the client facing checkin
  return get(order, 'data.order.rejected') !== undefined;
}

window.GETRAW = getRawLicense;
window.APPCONFIG = {};

export const loadConfig = async () => {
  const result = await getAppConfig();
  window.APPCONFIG = { ...(result || {}) };
  loadGPSID();
  return result;
};

export const getConfig = (key, fb) => {
  return get(window.APPCONFIG, key, fb);
}

// Built-in default landing per role, preserved when no config override is set:
//  0/1 (super/admin) -> Admin Dashboard, 2 (driver) -> Schedules, others -> /dashboard
const DEFAULT_LANDING_FALLBACK = {
  0: '/dashboard/admin',
  1: '/dashboard/admin',
  2: '/dashboard/manageSchedule',
};

// Where the top "Admin" tab (and the Admin/Super Admin initial landing) points.
// Configurable via the `admin.landingPath` setting (Edit Settings); defaults to
// the Admin Dashboard so behavior is unchanged when unset. Lets a client route
// admins straight to another admin page — e.g. when the Admin Dashboard is hidden.
export const getAdminLanding = () => {
  const configured = getConfig('admin.landingPath');
  return (typeof configured === 'string' && configured.trim()) ? configured.trim() : '/dashboard/admin';
}

// Resolve where a given role should land on login / page refresh. Configurable
// per role via the `defaultLanding.role_<N>` settings (Edit Settings); Admins and
// Super Admins otherwise follow the configurable Admin landing (getAdminLanding),
// and every role falls back to the historical behavior when nothing is set.
export const getDefaultLanding = (role) => {
  const configured = getConfig(`defaultLanding.role_${role}`);
  if (typeof configured === 'string' && configured.trim()) return configured.trim();
  if (role === 0 || role === 1) return getAdminLanding();
  return DEFAULT_LANDING_FALLBACK[role] || '/dashboard';
}

export const isIOS = () => {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac"))
}

export const copyToClipboard = (textToCopy) => {
  var textArea;

  function createTextArea(text) {
    textArea = document.createElement('textArea');
    textArea.readOnly = true;
    textArea.contentEditable = true;
    textArea.value = text;
    document.body.appendChild(textArea);
  }

  function selectText() {
    var range, selection;

    if (isIOS()) {
      range = document.createRange();
      range.selectNodeContents(textArea);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }
  }

  function copyTo() {
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }

  if (isIOS()) {
    createTextArea(textToCopy);
    selectText();
    copyTo();
  } else {
    copyToClipboardNotIos(textToCopy);
  }
}

export const copyToClipboardNotIos = text => {
  try {
    var copyText = document.createElement("textarea");
    document.body.appendChild(copyText);
    copyText.style = "display: inline; width: 1px; position: fixed; left: -999999px; top: -999999px;";
    copyText.value = text;
    copyText.focus();
    document.execCommand("SelectAll");
    document.execCommand("Copy");
    document.body.removeChild(copyText);
    if (get(navigator, 'clipboard.writeText')) {
      navigator.clipboard.writeText(text).then(() => 0);
    }
  } catch (err) {
    console.error(`Failed to copy text: ${err.message}`);
  }
};

export const orderHasManifest = order => {
  const isSigned = get(order, 'data.manifest.signed');
  const hasFile = get(order, 'data.manifest.filename');

  return {
    isSigned: !!isSigned,
    hasFile: !!hasFile,
    file: isSigned ? get(last(isSigned), 'filename') : hasFile,
  }
}

export const orderHasReconForm = order => {
  const hasLink = get(order, 'data.order.notes');
  const hasSig = get(order, 'data.order.signature.customer');
  const hasId = `${hasLink}`.split('_rec_').length > 1;

  return {
    isReconOrder: !!hasId && !!hasLink,
    hasLink,
    hasId,
    hasSig,
    file: getReconUrl(hasLink),
  }
}

export const fileToBuffer = file => {
  return new Promise((resolve, reject) => {
    try {
      const fileReader = new FileReader();
      fileReader.onload = function(){ resolve(this.result) };
      fileReader.readAsDataURL(file);
    } catch (err) {
      reject(err);
    }
  })
}

export const uploadManifest = async (file, order, force = false) => {
  try {
    const buff = await fileToBuffer(file);
    await sendManifest({
      pdf: buff,
      currentWindow: window.location,
      order,
      force,
    });
  } catch (err) {
    const error = get(err, 'response.data.error', err.message);
    throw new Error(error);
  }
}

export const uploadManifestWithConfirm = async (file, order, askOverwrite = true) => {
  try {
    await uploadManifest(file, order);
  } catch (err) {
    const error = get(err, 'response.data.error', err.message);

    if (error.toLowerCase().includes('licenses do not match')) {
      if (!askOverwrite) { 
        throw new Error('Licenses do not match');
      }
      const cont = window.confirm('The licenses do not match. Are you sure you want to upload this manifest? It will overwrite any existing manifests.')
      if (cont) {
        return uploadManifest(file, order, true)
      } else {
        throw new Error('Upload cancelled.')
      }
    }
    throw new Error(error);
  }
}

export const isNoShowRoute = (route = {}) => {
  const zip = get(route, 'zipCode');
  const name = get(route, 'name', '').toLowerCase().split(' ').join('');
  return zip == '00001' || name == 'noshoworders';
}

window.ISDEV = isDev;

export const DateTool = {
  // moment,
  markerDate: () => {
    return moment('2023-01-01');
  },
  dayStringToNum: (d) => {
    const days = {
      sun: 0,
      mon: 1,
      tues: 2,
      wed: 3,
      thurs: 4,
      fri: 5,
      sat: 6,
    }

    return days[d];
  },
  generateArray: function (type = 'all') {
    const start = this.markerDate(); //sun jan 01 2023

    const arr = [];

    // 0 is sunday
    const validdays = [1, 2, 3, 4, 5];
    // const validdays = [0, 6];

    for (let i = 0; i < 365; i++) {
      const day = moment(start).add(i, 'day');
      if (validdays.indexOf(day.day()) > -1) {
        arr.push(i);
      }
    }

    return arr;
  },
  dateToNum: function (date) {
    return moment(moment(date)).diff(this.markerDate(), 'days');
  },
  getDate: function (addDay) {
    return moment(this.markerDate()).add(addDay, 'days');
  },
  calToDate: function (obj) {
    const { day, month, year } = obj;

    const d = moment(`${year}-${month}-${day}`);

    const diff = d.diff(this.markerDate(), 'days');

    return diff;
  },
  isDateArray: function (d) {
    return Array.isArray(d) && typeof first(d) === 'number';
  },
  dateToCal: function (d) {
    const date = this.getDate(d).format('YYYY-MM-DD');
    const [year, month, day] = date.split('-').map(v => parseInt(v));
    return { day, month, year };
  },
  arrToDates: function (arr, format) {
    return arr.map(a => {
      const d = this.getDate(a);
      if (format) {
        return d.format(format);
      }
      return d;
    })
  },
  dateInArr: function (date, arr) {
    date = moment(date);
    const diff = date.diff(this.markerDate(), 'days');

    return arr.indexOf(diff) > -1;
  },
}

window.DATETOOL = DateTool;

window.MAPS = {};
window.GEO = {};
window.DIRSERVICE = {};

export const getGeoCode = (opts) => {
  return new Promise((resolve, reject) => {
    window.GEO.geocode(opts, function(results, status) {
      if (status == 'OK') {
        resolve(first(results));
      } else {
        reject(status);
      }
    });
  })
}

export const getDirections = async (opts) => {
  return new Promise((resolve, reject) => {
    window.DIRSERVICE.route(opts, function(results, status) {
      if (status == 'OK') {
        resolve(results);
      } else {
        reject(status);
      }
    });
  })
}

export const makeMap = (elem, opts = {}) => {
  opts = {
    zoom: 10,
    center: new window.google.maps.LatLng(2.8, -187.3),
    mapTypeId: "roadmap",
    mapId: "MAP",
    ...opts,
  }
  return new window.MAPS(elem, opts);
}

export const makeMarker = (opts = {}) => {
  return new window.google.maps.Marker(opts);
}

export const makeDirService = () => {
  return new window.google.maps.DirectionsService();
}

export const makeDirRenderer = (opts = {}) => {
  return new window.google.maps.DirectionsRenderer(opts);
}

async function initMap() {
  try {
    const { Map } = await window.google.maps.importLibrary("maps");
    window.GEO = new window.google.maps.Geocoder();
    window.MAPS = Map;
    window.DIRSERVICE = makeDirService();
  } catch (err) {
    console.error(err);
  }
}
initMap();

export const pickFrom = (obj, arr) => {
  const newobj = {};
  arr.map(k => {
    set(newobj, k, get(obj, k));
  })
  return newobj;
}

export const getManifestUrl = filename => {
	if (!filename) { return undefined };
	return `https://gps-manifests.s3.us-west-2.amazonaws.com/${filename}`;
}

export const getCopiesUrl = filename => {
	if (!filename) { return undefined };
	return `https://gps-copies.s3.us-west-2.amazonaws.com/${filename}`;
}

export const getFileUrl = filename => {
	if (!filename) { return undefined };
	return `https://gps-one-uploads.s3.us-west-2.amazonaws.com/${filename}`;
}

export const getReconUrl = filename => {
	if (!filename) { return undefined };
	return `https://gps-one-uploads.s3.us-west-2.amazonaws.com/${get(filename, '0.file', filename)}`;
}

export function mergeDeep(...objects) {
  const isObject = obj => obj && typeof obj === 'object';
  
  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key];
      const oVal = obj[key];
      
      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = oVal;
      }
      else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal);
      }
      else {
        prev[key] = oVal;
      }
    });
    
    return prev;
  }, {});
}

const ensureArray = item => {
  if (!item) { return [] }
  return Array.isArray(item) ? item : [item];
}

export const getAllLnsFromUser = user => {
  const main = get(user, 'company.License #');
  const others = ensureArray(get(user, 'company.licenseNumbers')).map(l => (l || '').trim()).filter(f => !!f);
  return { main, all: uniq([main, ...others]) }
}

export const saveWorksheet = (filename, ws) => {
  var blob = new Blob([ws], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement('a');
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

// Card #287 — build a spreadsheet straight from a page's antd column definitions, so an
// export can never list a different set of fields than the table it came from. This is how
// the LN export on the License Numbers page already works (it walks COLS() rather than a
// second hand-kept list); Drivers and Vehicles share it instead of repeating the plumbing.
//
// Each column becomes one sheet column, valued by its `exportValue` if it has one and by
// its dataIndex otherwise. A column that packs several fields behind a single dataIndex —
// the Vehicles "Misc" cell — declares `exportColumns` and expands into that many instead.
const exportColumnsFor = col => {
  if (_size(col.exportColumns)) { return col.exportColumns; }

  return [{
    title: col.title,
    value: row => {
      if (typeof col.exportValue === 'function') { return col.exportValue(row); }

      const val = get(row, col.dataIndex);

      // Same formatting returnRender() in _shared/editable-table gives a date cell: the
      // page shows the localised short date, not the stored YYYY-MM-DD.
      if (col.inputType === 'date' && !!val) {
        const m = moment(val);
        return m.isValid() ? m.format('L') : '';
      }

      return val;
    },
  }];
}

const exportCell = val => {
  if (val === null || val === undefined || val === '') { return ''; }
  if (isObject(val)) { return JSON.stringify(val); }
  return `${val}`;
}

export const exportTable = (cols = [], data = [], opts = {}) => {
  const columns = cols.reduce((acc, c) => [...acc, ...exportColumnsFor(c)], []);

  const rows = [
    columns.map(c => c.title),
    ...data.map(d => columns.map(c => exportCell(c.value(d)))),
  ];

  const ws = XLSX.utils.aoa_to_sheet(rows);

  // Widen every column to its longest cell (capped, so a Notes column can't run off the
  // screen) — otherwise the file opens with each header clipped to the default width.
  ws['!cols'] = columns.map((c, i) => ({
    wch: Math.min(60, rows.reduce((w, r) => Math.max(w, _size(r[i])), 10) + 2),
  }));

  const sheetName = get(opts, 'sheetName', 'Export');
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  XLSX.writeFile(wb, get(opts, 'filename', `${sheetName}-export-${moment().format('YYYY-MM-DD')}.xlsx`));
}

// Card #277 — one search box per page, matching everything the page actually shows.
// Same trick as exportTable above and deliberately the same column definitions: a page
// that has told its COLS how to export a cell has already told them how to search it, so
// the search can never drift out of step with the grid the way a hand-kept list of field
// names does. (Every page's search used to be such a list — usually two or three fields,
// so a value sitting in plain sight in a fourth column simply could not be found.)
//
// A select cell shows its option TITLE, not the value stored behind it — _shared/editable
// -table's returnRender() resolves it through `options`, so searching has to as well, or
// the status you can read on screen is not the status you can type in the box.
const selectOptionTitle = (col, val) => {
  if (val === null || val === undefined || val === '') { return val; }

  // Loose compare, matching returnRender(): these values arrive as both 1 and '1'.
  const found = (col.options || []).find(o => `${get(o, 'value')}` === `${val}`);
  return get(found, 'title', val);
}

// Reading the text back out of what a column's `render` actually drew. Some tables — the
// Shipping and Admin dashboard report sections, the Reconciliations list — declare every
// column as `{ title, key, render }` with no dataIndex at all, so there is no field to
// read and the fallback chain above would find nothing whatsoever to match.
//
// Walking the returned React element is opt-in per page via `{ useRender: true }` and is
// run as a second pass (see rowMatchesSearch), because it builds an element per cell:
// free on a ten-row summary table, wasteful across a few thousand orders. A renderer that
// throws, or that draws through a nested component React has not expanded yet (a pill, an
// avatar), contributes nothing rather than breaking the search — which is what the
// `searchValue` hook is there for.
const elementText = (node, depth = 0) => {
  if (node === null || node === undefined || typeof node === 'boolean') { return ''; }
  if (depth > 8) { return ''; }
  if (Array.isArray(node)) { return node.map(n => elementText(n, depth + 1)).join(' '); }

  if (typeof node === 'object') {
    // `title` as well as children: a status cell is an <Icon title="Delivered" /> with no
    // text of its own, and "Delivered" is exactly the word someone searches for.
    const title = get(node, 'props.title');
    const own = typeof title === 'string' ? `${title} ` : '';
    return own + elementText(get(node, 'props.children'), depth + 1);
  }

  return `${node}`;
}

const renderedCellText = (col, row, index) => {
  if (typeof col.render !== 'function') { return ''; }

  try {
    return elementText(col.render(get(row, col.dataIndex), row, index));
  } catch (err) {
    return '';
  }
}

// What a column says about a row WITHOUT rendering it: `exportValue`/`exportColumns` if
// the column declares them (card #287's hooks, reused untouched), otherwise the dataIndex
// value formatted the way the cell paints it.
const columnDataText = (col, row, index) => {
  const plain = typeof col.exportValue !== 'function' && !_size(col.exportColumns);

  if (plain && col.inputType === 'select') {
    return exportCell(selectOptionTitle(col, get(row, col.dataIndex)));
  }

  // A boolean flag is searchable on whatever its cell actually PAINTS, which is a question
  // about the renderer and not about the value's JS type. License Numbers' Active and
  // Man. Req columns are `singlecheckbox` fields whose render prints the literal words
  // `true`/`false`, so "true" has to find them; a column that draws a tick, an icon or
  // nothing at all has no text to match and must not answer to "fal"/"als"/"no".
  //
  // Asking the renderer settles both cases with one rule: elementText() reads the words
  // out of a render that writes words and returns '' for one that only draws a glyph, and
  // renderedCellText() returns '' when the column has no render of its own — which is the
  // bare boolean, and React paints nothing for that either. Cheap enough to sit in the
  // no-render pass because it is only ever reached by a cell holding a boolean.
  if (plain && typeof get(row, col.dataIndex) === 'boolean') {
    return renderedCellText(col, row, index);
  }

  return exportColumnsFor(col).map(c => exportCell(c.value(row))).join(' ');
}

// The searchable text one column contributes for one row, resolved in this order:
//
//   1. `col.searchValue(row)` — the escape hatch, for a cell whose text is built from
//      something other than its dataIndex (License Numbers' Billing and Pickup Route
//      columns render `[{key, value}]` and route ids as human titles).
//   2. `col.exportValue` / `col.exportColumns` — card #287's hooks.
//   3. `get(row, col.dataIndex)`, formatted as the cell paints it.
//
// A column with a custom `render` but no hook still searches its dataIndex, which is the
// right answer whenever the renderer only decorates the value it was handed — a coloured
// tag, a link, a bolded name. Where the renderer REPLACES the value outright, the column
// either declares `searchValue` or the page opts into the rendered-text pass below.
//
// Exported so a page can reuse this exact derivation for its own per-column search
// dropdowns and sorters (All Accounts does) instead of keeping a second copy that can
// disagree with the global box about what a cell says.
//
// Guarded exactly like renderedCellText below, and for the same reason: a hook is page
// code and page code makes assumptions about its rows that one row will not hold. The
// Delivery Schedule's Days hook assumed every route stores day NAMES and threw on the one
// route that stores strict dates; because the throw escaped from here it propagated out
// of the caller's filter and killed search for the ENTIRE page, not for that one cell.
// A column that cannot say what a row holds now contributes nothing and the remaining
// columns still answer, so one malformed record can only ever cost its own match.
export const columnText = (col, row, index = 0) => {
  try {
    if (typeof col.searchValue === 'function') { return exportCell(col.searchValue(row)); }

    return columnDataText(col, row, index);
  } catch (err) {
    return '';
  }
}

export const rowMatchesSearch = (cols = [], row, term, opts = {}, index = 0) => {
  if (!term) { return true; }

  const needle = `${term}`.toLowerCase();
  const hit = text => text.toLowerCase().indexOf(needle) > -1;

  // Two passes, cheapest first. Everything a column can say without being rendered — its
  // searchValue hook, its export hook, its dataIndex — is checked across every column
  // before any renderer runs, and `.some` short-circuits on the first hit.
  if (cols.some(col => hit(columnText(col, row, index)))) { return true; }

  if (!opts.useRender) { return false; }

  // Only then, and only for a page that asked for it, the cells themselves. Kept as a
  // separate pass rather than concatenated onto the text above, so a term can never match
  // by straddling the join between a cell's value and its rendered output. A column with
  // a searchValue hook is skipped: the hook is the answer for that column.
  return cols.some(col => !col.searchValue && hit(renderedCellText(col, row, index)));
}

// What a page calls: `searchTable(COLS, rows, term)`. Partial and case-insensitive, over
// every column the grid renders. Returns `data` untouched while the box is empty, so a
// page pays nothing for having a search box it is not using.
export const searchTable = (cols = [], data = [], term, opts = {}) => {
  if (!term) { return data; }

  return data.filter((row, i) => rowMatchesSearch(cols, row, term, opts, i));
}

// A date as a number that sorts chronologically, or null when there is none to sort on.
// Exported for the columns whose date sits behind a render rather than an inputType.
export const sortableDate = val => {
  if (!val) { return null; }

  const m = moment(val);
  return m.isValid() ? m.valueOf() : null;
}

// Card #277 round 3 — what one column sorts a row on. Its cell text by default, which is
// right for names, addresses, ids and labels, but three kinds of cell would sort wrongly
// as text:
//
//   - a 'date' cell paints MM/DD/YYYY, which orders by month before year, so it sorts on
//     the date itself;
//   - a 'number' cell sorts as a number: numeric collation alone reads the digits after a
//     decimal point as a second whole number and puts -10 after -5;
//   - an 'upload' cell paints a View File button and nothing else, so it sorts on whether
//     there is a file rather than on a stored filename nobody can see.
//
// Any other cell whose text is not in its dataIndex (worked out from other fields, composed
// from several, or a column with no dataIndex at all) declares `sortValue(row)` and returns
// a number or text. Guarded like columnText: a comparator that throws takes the whole grid
// down mid-render, not just the one cell.
const sortKey = (col, row) => {
  try {
    if (typeof col.sortValue === 'function') { return col.sortValue(row); }

    const val = get(row, col.dataIndex);

    if (col.inputType === 'date') { return sortableDate(val); }
    if (col.inputType === 'number') { return parseFloat(val); }
    if (col.inputType === 'upload') { return val ? 1 : null; }

    return columnText(col, row);
  } catch (err) {
    return null;
  }
}

const isBlankSortKey = key => key === null || key === undefined
  || (typeof key === 'number' ? isNaN(key) : `${key}`.trim() === '');

// Blank sorts first ascending and last descending, which is where an empty cell has always
// sorted on License Numbers (and where its Add New LN row expects to be). Numbers sort
// before text, so a column mixing the two ("CUSTOMER PICKUP" among the return dates) still
// has one consistent order instead of depending on which pair the sort compares.
const compareSortKeys = (a, b) => {
  const aBlank = isBlankSortKey(a);
  const bBlank = isBlankSortKey(b);
  if (aBlank || bBlank) { return aBlank === bBlank ? 0 : (aBlank ? -1 : 1); }

  const aNum = typeof a === 'number';
  const bNum = typeof b === 'number';
  if (aNum && bNum) { return a - b; }
  if (aNum !== bNum) { return aNum ? -1 : 1; }

  return `${a}`.localeCompare(`${b}`, undefined, { numeric: true, sensitivity: 'base' });
}

// Sorting on every column, hoisted out of License Numbers (card 286) so it rides along
// with the search that shares its cell-text derivation. numeric:true keeps identifiers in
// human order — 000-00009 before 000-00010 rather than lexical order. A column that
// already defines its own `sorter` keeps it.
//
// antd sorts a copy of the rows it is given and never reorders the array itself, so a
// page's own list, and every edit, save and delete that looks a row up in it, keeps the
// order the page loaded it in whatever the grid is showing.
export const columnSorter = col => (a, b) => compareSortKeys(sortKey(col, a), sortKey(col, b));

export const withSorters = (cols = []) => cols.map(col => ({
  ...col,
  sorter: col.sorter || columnSorter(col),
  sortDirections: col.sortDirections || ['ascend', 'descend'],
}));

// Card #277 — the counterpart to searchTable for an EditableFormTable. That component
// hands its `updateData` callback exactly the array it was given to render, so the moment
// a search filters that array the callback's view of the table is a SUBSET. A page that
// diffs it against its full list to work out which rows were deleted (Drivers and
// Vehicles both do) would read every row the search hid as deleted and remove it from the
// database. This stitches the two views back together:
//
//   rows    — the page's full list
//   shown   — what the grid was actually given (the search hits)
//   updated — what EditableFormTable handed back
//
// Returns `{ data, removed }`: the rebuilt full list, and ONLY those rows that were on
// screen and genuinely went away. A row the search hid was never on screen, so it was
// never a candidate for deletion; a row added while a search was active is not in `rows`
// yet, so it is appended.
export const mergeTableEdits = (rows = [], shown = [], updated = [], key = 'id') => {
  const keyOf = r => `${get(r, key)}`;
  const kept = keyBy(updated, key);
  const wasShown = keyBy(shown, key);

  const removed = rows.filter(r => !!wasShown[keyOf(r)] && !kept[keyOf(r)]);

  const data = [
    ...rows.filter(r => !wasShown[keyOf(r)] || !!kept[keyOf(r)]).map(r => kept[keyOf(r)] || r),
    ...updated.filter(r => !rows.some(x => keyOf(x) === keyOf(r))),
  ];

  return { data, removed };
}

export const searchArray = (arr = [], opts = {}) => {
  const textToSearch = `${get(opts, 'searchTerm', '')}`.toLowerCase();
  const keys = get(opts, 'keys', []);

  return arr.filter(obj => {
    return !!keys.find(k => {
      const okey = get(obj, k);

      let ostr = isObject(okey) ? JSON.stringify(okey) : `${okey}`;

      return `${ostr}`.toLowerCase().includes(textToSearch);
    });
  })
}

export const fixDate = d => {
  if (!d) { return d }

  return d.includes('Z') ? d : `${d}Z`;
}

export const replaceURLWithHTMLLinks = (text) => {
  const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
  return `${text || ''}`.replace(exp, "<a href='$1' target='_blank'>Link <i class='fas fa-external-link-alt'></i></a>");
}